export const MainConfig = {
    AppDetails: {
        app_name: "Active Rides", 
        app_description: "This is the Nigeria taxi company App",
        app_identifier: "com.activerides.taxi.company.app",
        ios_app_version: "1.0.14", 
        android_app_version: 1014
    },
    FirebaseConfig: {
        apiKey: "AIzaSyBT8nUw4TYGizsmvQPoO_3jvFVdyZx7w3E",
        authDomain: "active-rides-602d0.firebaseapp.com",
        databaseURL: "https://active-rides-602d0-default-rtdb.firebaseio.com",
        projectId: "active-rides-602d0",
        storageBucket: "active-rides-602d0.appspot.com",
        messagingSenderId: "138574804358",
        appId: "1:138574804358:web:6d3a9debf7481489a9e807",
        measurementId: "G-RJXC8P47KE"
    },
    Google_Map_Key: "AIzaSyBT8nUw4TYGizsmvQPoO_3jvFVdyZx7w3E",
    facebookAppId: "828821441056930",
    PurchaseDetails: {
        CodeCanyon_Purchase_Code: "d6d2c306-3513-40f5-977c-507c68a5c6dc",
        Buyer_Email_Address: "redflairmultimedia@gmail.com"
    }
}